module.exports = {
  "general.days": "days",
  "general.continue": "Continue",
  "general.reservation": "Reservation",
  "general.country": "Country",
  "general.guest": "Guest",
  "general.guests": "Guests",
  "general.guests.one": "1 Guest",
  "general.guests.other": "{0} Guests",
  "general.single.beds.one": "1 Single bed",
  "general.single.beds.other": "{0} Single beds",
  "general.double.beds.one": "1 Double bed",
  "general.double.beds.other": "{0} Double beds",
  "general.interests": "Interests",
  "general.interests_hostz": "Arrival Info",
  "general.interests_offgrid": "Extras",
  "general.payments": "Payments",
  "general.summary": "Summary",
  "general.summary_offgrid": "Overview",
  "general.back": "Back",
  "general.buy": "Buy",
  "general.go-back": "Go Back",
  "general.next": "Next",
  "general.next_offgrid": "Next",
  "general.confirm": "Confirm",
  "general.cancel": "Cancel",
  "general.close": "Close",
  "general.save": "Save",
  "general.stay": "Stay",
  "general.identify-using-qr": "Identify me using QR",
  "general.identify-using-code": "Identify me using Code",
  "general.identify-welcome": "Welcome",
  "general.identify-welcome-phrase": "Please proceed to complete the pre-check-in so we can have everything ready for your arrival.",
  "general.identify-welcome-phrase-offgrid": "Please complete your online check-in as soon as possible. You will receive the arrival information one day before your arrival.",

  "general.identify-screen.title": "Access your digital assistant for your stay:",
  "general.identify-screen.subtitle": "With your booking code or your data if you are already at the hotel",
  "general.identify-screen.subtitle-1": "Complete the information to continue",
  "general.identify-screen.subtitle-2": "Please complete the following information to continue",
  "general.identify-screen.button-code": "I have a booking code",
  "general.identify-screen.button-data": "I'm alredy checked in",
  "general.identify-screen.button-identify": "Continue",
  "general.identify-screen.button-return-code": "Back to booking code identification",
  "general.identify-screen.button-return-data": "Back to reservation data identification",
  "general.identify-screen.error-code": "We couldn't find the booking code provided, please try again!",
  "general.identify-screen.error-data": "We couldn't find the reservation with the provided data, please try again!",
  "general.identify-screen.title-hostz": "Check in now and access your guests portal:",

  "general.active": "Active",
  "general.inactive": "Inactive",
  "general.go-to-detail": "Go to Detail",
  "general.go_to_website": "Learn more",
  "general.go-to-my-stay": "Go to My Stay",
  "general.guidelines": "Guidelines",
  "general.price": "Price",
  "general.report": "Report",
  "general.edit": "Edit",
  "general.checkin_edit": "Edit Check-in Info",
  "general.experiences": "Experiences",
  "general.request": "Request",
  "general.send": "Send",
  "general.detail": "Detail",
  "general.no-charge": "Free",
  "general.yes": "YES",
  "general.no": "NO",
  "general.dateformat": "MM-dd-yyyy",
  "general.short-dateformat": "MM-dd",
  "general.day": "Day",
  "general.date": "Date",
  "general.hour": "Hour",
  "general.time": "Time",
  "general.qty": "Qty",
  "general.reserve": "Book",
  "general.from": "From",
  "general.to": "To",
  "general.total": "Total",
  "general.duration": "Duration",
  "general.chat": "Chat",
  "general.services": "Services",
  "general.equipment": "Equipment",
  "general.features": "Features",
  "general.remove": "Remove",
  "general.upload": "Upload",
  "general.upload-file": "Upload File",
  "general.balance": "Balance",
  "general.checkout": "Check Out",
  "general.accept": "Accept",
  "general.clear": "Clear",
  "general.send_comment": "Send Comment",
  "general.menu": "Menus",
  "general.start.checkin": "Start Check-in",
  "general.placeOrder": "Place Order",
  "general.updateOrder": "Update Order",
  "general.please": "Please",
  "general.touch": "Please touch ",
  "general.key_explanation": "This key will be provided by the concierge",
  "general.selected": "Selected",
  "general.select-date": "Please select the day, time, and number of people for your reservation",
  "general.today": "Today",
  "general.time-format": " hrs",
  "general.yesterday": "Yesterday",
  "general.tomorrow": "Tomorrow",
  "general.no-schedule-available": "Sorry, no Schedule Available",
  "general.fields_required": "are required fields",
  "general.about": "About",
  "general.type_message": "Type your message here...",
  "general.items.qty": "Qty Items",
  "general.add-to-home-screen-text": "You can add this page to your home screen for quick access.",
  "general.add-to-home-screen-button": "Add to home screen",
  "general.hs": ":00",
  "general.hs-abrev": ".",
  "general.min": "min.",
  "general.select_option": "Select an option...",
  "general.customization": "Configure your add-on...",

  "hotel.website": "Website",
  "hotel.phones": "Phones",
  "hotel.address": "Address",
  "hotel.contact-us": "Contact Us",
  "hotel.social-networks": "Social Networks",
  "hotel.please-feel":
    "Please feel free to contact us!. Contact information below.",
  "hotel.location": "Location",
  "hotel.conditioning-air-in-common-spaces":
    "Conditioning Air in commons spaces",
  "hotel.parking": "Parking",
  "hotel.free-parking": "Free Parking",
  "hotel.pay-parking": "Pay Parking",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Esthetic Center",
  "hotel.kids-club": "Kids Club",
  "hotel.luggage-storage": "Luggage Storage",
  "hotel.breakfast": "Breakfast",
  "hotel.breakfast-buffet": "Breakfast Buffet",
  "hotel.smoke-free-space": "Smoke Free Space",
  "hotel.fitness-center": "Fitness center",
  "hotel.gay-friendly": "Gay Friendly",
  "hotel.hydromassage": "Hydromassage",
  "hotel.gardens": "Gardens",
  "hotel.masseuse-available": "Masseuse Available",
  "hotel.water-park": "Water Park",
  "hotel.hairdressing": "Hairdressing",
  "hotel.bilingual-staff-english-spanish":
    "Bilingual Staff (English / Spanish)",
  "hotel.pet-friendly": "Pet Friendly",
  "hotel.pool": "Pool",
  "hotel.smoking-points": "Smoking Points",
  "hotel.reception-24-hs": "Reception 24hs",
  "hotel.restaurant": "Restaurant",
  "hotel.restaurant-to-the-card": "Restaurant to the card",
  "hotel.theme-restaurant": "Theme Restaurant",
  "hotel.congress-hall": "Congress Hall",
  "hotel.meeting-room": "Meeting Room",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Laundry Service",
  "hotel.babycare-service": "Babycare Service",
  "hotel.spa": "Spa",
  "hotel.theater": "Theater",
  "hotel.terraces": "Terraces",
  "hotel.souvenir-shop": "Souvenir Shop",
  "hotel.airport-transfer": "Airport transfer on demand",
  "hotel.covid.protected-medical-area": "Protected Medical Area",
  "hotel.covid.virtual-check-in-out": "Virtual Check-In / Out",
  "hotel.covid.temperature-check": "Temperature Check",
  "hotel.covid.first-aid-kit-available": "First Aid Kit Available",
  "hotel.covid.separation-screens-for-personnel":
    "Separation Screen for Personnel",
  "hotel.covid.contactless-payment-available": "Contactless Payment Available",
  "hotel.covid.sanitizers-in-common-areas": "Sanitizers in Common Areas",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid":
    "Use of Specific Cleaning Articles for Covid",
  "checkin.checkin.preparing-title": "Preparing your Check-In",
  "checkin.checkin.preparing-text": "Please do not close or refresh this window.",
  "checkin.status": "Check-in Status",
  "checkin.status-pending": "Pending",
  "checkin.status-observed": "Action Required",
  "checkin.status-to_validate": "Processing",

  "checkin.status-to_validate-text--":
    "<b>That's all for now!</b> We will check the information and send you a confirmation message shortly! Regards!",
  "checkin.status-to_validate-text":
    "<b>That's all for now!</b> Thanks for completing the web check-in. Best regards",

  "checkin.status-in_progress": "In Progress",
  "checkin.status-accepted": "Accepted",
  "checkin.status-accepted-text":
    "<b>Your Check-in was successfully completed!</b> We are looking forward to having you! Have a nice trip!",
  "checkin.status-no_show": "No Show",
  "checkin.status-no_show-text":
    "Please contact us using the chat button below in case you want to reschedule your original reservation. Hope to see you soon!",
  "checkin.status-canceled": "Canceled",
  "checkin.status-canceled-text":
    "Your reservation has been canceled. Please contact us using the chat button below if you think this is a mistake or if you want to change it. Thanks!",
  "checkin.status-done": "Checked Out",
  "checkin.status-done-text":
    "Your stay has been completed! Get in touch with us using the chat button below. Thank you!",
  "checkin.please-complete":
    "Please fill in this form to complete the check-in process. If you already have a check-in code enter it ",
  "checkin.not-forget":
    "Don't forget to add all the people that are traveling with you. You will be able to enter their information after completing this form.",
  "checkin.initiated": "My Check-in",
  "checkin.stay": "Stay",
  "checkin.in": "Entry date",
  "checkin.out": "Departure date",
  "checkin.travel-type": "Type of Travel",
  "checkin.inputs.select": "Select",
  "checkin.inputs.email": "Email",
  "checkin.inputs.travelType": "Travel Type",
  "checkin.inputs.dni-number": "Number",
  "checkin.inputs.dni-number-offgrid": "Number",
  "checkin.inputs.dni-issue-date": "Issue Date",
  "checkin.inputs.dni-issue-date-offgrid": "Valid until",
  "checkin.inputs.dni-issue-date-simplex": "Valid until",
  "checkin.inputs.dniType": "ID Type ",
  "checkin.inputs.zipCode": "ZipCode",
  "checkin.inputs.dni": "ID number",
  "checkin.inputs.dniIssueDate": "ID Issue Date",
  "checkin.inputs.dniIssueDate-offgrid": "Valid until",
  "checkin.inputs.dniIssueDate-simplex": "Valid until",
  "checkin.inputs.name": "Name",
  "checkin.inputs.surname": "Surname",
  "checkin.inputs.gender": "Gender",
  "checkin.inputs.gender.male": "Male",
  "checkin.inputs.gender.female": "Female",
  "checkin.inputs.gender.other": "Other",
  "checkin.inputs.date-of-birth": "Date of Birth",
  "checkin.inputs.address": "Address",
  "checkin.inputs.postal-code": "ZipCode",
  "checkin.inputs.nationality": "Nationality",
  "checkin.inputs.residence": "Residence",
  "checkin.inputs.country_of_residence": "Country of Residence",
  "checkin.inputs.birthday": "Date of Birth",
  "checkin.inputs.city": "City",
  "checkin.inputs.phone": "Phone",
  "checkin.inputs.passenger": "Passenger Data",
  "checkin.inputs.photos_dniFront": "ID Front",
  "checkin.inputs.photos_dniBack": "ID Back",
  "checkin.inputs.photos_selfie": "Selfie",
  "checkin.document-info": "Document Information",
  "checkin.personal-info": "Personal Information",
  "checkin.location": "Location",

  "checkin.inputs.entryTime": "Time of Arrival",
  "checkin.inputs.arrivalMode": "How will you arrive?",
  "checkin.inputs.extraData_qtyAdults": "Adults",
  "checkin.inputs.extraData_qtyChild": "Child",
  "checkin.inputs.extraData_qtyBabies": "Babies",

  "checkin.identificate": "Verify identity",

  "checkin.passenger": "Guest",
  "checkin.passengers": "Guests",
  "checkin.passengers-list": "Guests List",
  "checkin.passengers-error-incomplete": "Please complete guest information",
  "checkin.add-passenger": "Add Guest",
  "checkin.arrivalMode": "Arrival Mode",
  "checkin.arrivalMode-hostz": "How will you arrive?",
  "checkin.arrivalMode-text": "Please select the mode of arrival",
  "checkin.arrivalMode.airplane": "Airplane",
  "checkin.arrivalMode.public_transportation": "Public Transportation (Bus/Train)",
  "checkin.arrivalMode.train": "Train",
  "checkin.arrivalMode.bus": "Bus",
  "checkin.arrivalMode.car": "Car",
  "checkin.arrivalMode.other": "Other",
  "checkin.save-checkin": "Save Check-In",
  "checkin.save-changes": "Save Changes",
  "checkin.update-info": "Update Info",
  "checkin.reservation-data": "Reservation Info",
  "checkin.request-photos":
    "Please make sure the pictures are in focus and legible. You can crop and resize the images after taking them.",
  "checkin.reviewing":
    "Thank you! We are reviewing your request. You will receive a notification regarding <b>the status of your check-in</b> shortly.",
  "checkin.remember-can":
    "Remember you can still modify your check-in information.",
  "checkin.can-see":
    "You can see the check-in history and add a comment below.",
  "checkin.please-read-to-change":
    "Please read the information below and make the necessary changes in order to proceed.",
  "checkin.modify": "Modify",
  "checkin.edit-data": "Edit Data",
  "checkin.accept": "Accept",
  "checkin.dni-front": "ID Front",
  "checkin.dni-back": "ID Back",
  "checkin.camera": "Camera",
  "checkin.date-of-birth": "Date of Birth",
  "checkin.age": "Age",
  "checkin.add-comment": "Add Comment",
  "checkin.me": "Me",
  "checkin.accepted-text":
    "<b>Your Check-In has been accepted!</b> We look forward to seeing you! Remember you can ask us anything in the comment section below. Have a nice trip!",
  "checkin.canceled-text":
    "<b>Your Check-In has been canceled.</b> Please read the comments below to know how to proceed. Thanks!",
  "checkin.new-checkin": "New Check-In",
  "checkin.use-button-to-add-guest":
    "Use the button below to add other guests.",
  "checkin.identified": "Identified Check-In!",
  "checkin.identify-error":
    "We could not find the indicated reservation code, please try again!",
  "checkin.time-of-arrival": "Time of Arrival",
  "checkin.time-of-arrival-text":
    "If you already have an estimated time of arrival let us know here.",
  "checkin.time-of-arrival-text2": "Remember our guaranteed check in time is {0}hr.",
  "checkin.time-of-arrival-text2-hostz": "Remember our regular check-in time is at {0}hr.",
  "checkin.time-of-arrival-text2-offgrid": "Your room is ready at {0}hr.",
  "checkin.time-of-arrival-early-checkin":
    "Request <b>Early Check-In</b> <span class='text-muted'>(subject to availability)</span>",
  "checkin.e-mail": "E-Mail",
  "checkin.phone": "Phone",
  "checkin.guest-data": "Guest Data",
  "checkin.guest-data-text":
    "Please complete the missing information to complete your online check-in process.",
  "checkin.guest-complete-later": "Complete this information later.",
  "checkin.id-type.id": "ID",
  "checkin.id-type.passport": "PASSPORT",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Type of Travel",
  "checkin.type-of-travel-text":
    "We will personalize your experience according to your preferences and needs.",
  "checkin.travel-type.couple": "Couple",
  "checkin.travel-type.congress": "Congress",
  "checkin.travel-type.family": "Family Trip",
  "checkin.travel-type.business": "Business",
  "checkin.travel-type.event": "Event",
  "checkin.travel-type.friends": "Friends trip",
  "checkin.travel-type.relaxing": "Relaxing",
  "checkin.travel-type.party": "Party Travel",
  "checkin.travel-type.single_traveler": "Single Traveler",
  "checkin.travel-type.leisure": "Leisure trip",
  "checkin.company-information": "Company Information",
  "checkin.company-country": "Country",
  "checkin.company-country-placeholder": "Select country",
  "checkin.company-zip-code": "Zip Code",
  "checkin.company-zip-code-placeholder": "Enter zip code",
  "checkin.company-city": "City",
  "checkin.company-city-placeholder": "Enter city",
  "checkin.company-information-text": "Please provide your company information.",
  "checkin.company-name": "Name",
  "checkin.company-name-placeholder": "Enter name",
  "checkin.company-address": "Address",
  "checkin.company-address-placeholder": "Enter address",
  "checkin.room-preferences": "Room Preferences",
  "checkin.room-preferences-text":
    "Do you have any preferences for your room? <br />Let us know here:",
  "checkin.room-preferences.close-to-elevator": "Close to the Elevator",
  "checkin.room-preferences.far-from-elevator": "Far from the Elevator",
  "checkin.room-preferences.wheelchair-accessible": "Wheel chair Accessible",
  "checkin.room-preferences.lower-floor": "Lower floor Room",
  "checkin.room-preferences.higher-floor": "Higher floor Room",
  "checkin.take-care-environment": "Want to help take care of the environment?",
  "checkin.take-care-environment-text":
    "Small things can significantly reduce your environmental footprint during your stay.",
  "checkin.take-care-environment.housekeeping-frequency":
    "Housekeeping Frequency",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Everyday",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day":
    "Every other Day",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room":
    "Do not clean my Room",
  "checkin.take-care-environment.towell-replacement-frequency":
    "Towell Replacement Frequency",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change":
    "Do not change Towells",
  "checkin.take-care-environment.towell-replacement-frequency.everyday":
    "Everyday",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day":
    "Every other Day",
  "checkin.restaurant-reservation":
    "I'm interested in making a reservation on your <b>restaurant/s</b>",
  "checkin.comments": "Comments",
  "checkin.comments-text":
    "Please let us know if there is anything we can do to improve your stay with us.",
  "checkin.review-the-summary":
    'Please review the summary of your online Check-in. You can go back and edit any of the information you just provided. If everything is correct press the <b>"Confirm"</b> button below.',
  "checkin.reservation-code": "Reservation Code",
  "checkin.in-out": "In / Out",
  "checkin.primary-guest": "Primary Guest",
  "checkin.guests-text": "We need this information to determine the best bed configuration for your stay and ensure your comfort.<br /><br /><small>Adult (15+ years) / Child (3-14 years) / Baby (0-2 years)</small>",
  "checkin.adult-s": "Adult(s)",
  "checkin.adults": "Adults",
  "checkin.adult": "Adult",
  "checkin.short-room": "Room",
  "checkin.room": "Room",
  "checkin.select-door-open": "Please select which door do you want to open...",
  "checkin.select-door-open-hostz": "Click on the door you wish to open",
  "checkin.select-door-open-themyde": "Select a door below and swipe to unlock.",
  "checkin.select-photo-source-to": "Select the photo source to ",
  "checkin.use-camera": "Use Camera",
  "checkin.click-edit-data-text1": " to make the necessary modifications. Once you've made the changes, press ",
  "checkin.click-edit-data-text2": " and then ",
  "checkin.click-edit-data-text3": ". Thank you for your collaboration!",
  "checkin.do-not-disturb": "Do Not Disturb",
  "checkin.floor-selection": "Mobility issues?",
  "checkin.floor-selection-text": "Please select the floor where you want to check in. Kindly note that we do not have elevators.",
  "checkin.ground-floor": "I have mobility issues and need as few steps as possible",
  "checkin.first-floor": "First Floor",
  "checkin.indifferent": "Indifferent",
  "checkin.entry-time-not-know-yet": "I don't know yet",
  "checkout.loading-information": "Please hold on while I gather all the necessary information.",
  "checkout.errors-title": "Unable to process your Check-out",
  "checkout.error-balance":
    "Your balance stands at {0}. Kindly settle your account in order to proceed.",
  "checkout.error-departure":
    "Your Check-out date is {0}. Would you like to shorten your stay?",
  "checkout.button": "Continue with Checkout",
  'checkout.error-departure-button': "Need help? Chat with us!",
  'checkout.error-noShowBalance': "Need assistance or have questions? We've got you covered! Click the chat button below to get in touch. Want to cancel your account? You can easily do that here, too. Remember, your satisfaction is our top priority",

  "checkout.success-title": "Your CheckOut has been successful!",
  "checkout.debt": "We cannot process the checkout. Your stay has an outstanding balance of: ",
  "checkout.pay_now": "Pay Now",
  "checkout.ask_for_balance": "Unfortunately, we are unable to process the checkout right now. Please chat with us for further instructions.",
  "checkin.selfie.preview-title": "Selfie",
  "checkin.selfie.preview-text": "Crop the image to center your face.",
  "checkin.dniFront.preview-title": "ID Front",
  "checkin.dniFront.preview-text": "Crop the image to properly center your document.",
  "checkin.dniBack.preview-title": "ID Back",
  "checkin.dniBack.preview-text": "Crop the image to properly center your document.",
  "checkin.redirecting": "Redirecting in {0} seconds...",
  "checkin.camera.repeat": "Repeat",
  "checkin.camera.crop": "Crop",
  "checkin.camera.use-photo": "Use Photo",
  "checkin.reservation-conditions-text": "Management takes no responsibilly for valuables left in the guest room.<br /><br /><b>Check-out time is 11:00 a.m.</b><br /><br /><span class='text-danger font-weight-bold'>Smoking is not allowed in all our Guest Rooms and in all public area.</span><br />Smoking is only allowed outside the building on the street. Should you still smoke in the room we have to charge a cleaning fee of Euro 250,00.<br /><br /><small>Above mentioned data are handled by EDP.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in:</b> from 3 PM<br/><b>Check-out:</b> until 11 AM<br/><ul><li>Smoking is prohibited in all our cabins.</li><li>Please note that only registered guests are allowed to stay and sleep in the cabin. The maximum number of guests is 2 people.</li><li>Please report damages and defects immediately via “Damage Report” in your guide or contact us through our hotline: +49 30 54806375.</li><li>Travel to and use of our off-grid accommodations are at your own risk; we accept no liability for weather-related restrictions, road conditions, or accidents. Detailed regulations can be found in our terms and conditions.</li></ul><br/>An overview of our cabin rules can be found in your travel guide under “Your Cabin“ -> “Cabin Rules“.",

  "checkin.gdpr-text1": "By signing below, I consent to the processing of my personal data in accordance with the",
  "checkin.gdpr-text2": ". I understand that I can withdraw my consent at any time.",
  "checkin.gdpr-text-nexo": "and the",

  "checkin.gdpr-text1-costa": "By signing below, I consent to the processing of my personal data as outlined in the",
  "checkin.gdpr-text2-costa": ", and I declare that I am not a tax resident in the Argentine Republic, as per ",
  "checkin.gdpr-text-nexo-costa": ", and understand that I can withdraw my consent at any time. I also confirm that I have read and accept the ",
  "checkin.gdpr-text3-costa": "I declare that my stay in Argentina is for tourism and does not exceed the legally allowed period, in order to request a VAT refund under Law N° 3971 (AFIP) and Resolution N° 566.",
  "checkin.gdpr-button-2-popup": "I declare that my stay in Argentina does not exceed the stablished maximum term, according to the current immigration legislation and my reason to visit Argentina is for tourism only.<br />The present AFFIDAVIT serves for the purposes of issuing the VAT exemption request, due to the General Resolution N° 3971(AFIP) and Resolution N°566(tourism)",

  "checkin.gdpr-text1-hostz": "By signing below, I consent to the processing of my personal data in accordance with the",
  "checkin.gdpr-text2-hostz": ".",
  "checkin.gdpr-text-nexo-hostz": " and I understand that I can withdraw my consent at any time.<br/><br/>I acknowledge and agree to abide by the ",

  "checkin.gdpr-text1-simplex": "By signing below, I consent to the processing of my personal data in accordance with the",
  "checkin.gdpr-text2-simplex": ".",
  "checkin.gdpr-text-nexo-simplex": " and I understand that I can withdraw my consent at any time.<br/><br/>I acknowledge and agree to abide by the ",

  "checkin.gdpr-text1-offgrid": "By signing below, I agree to the processing and use of my personal data in accordance with the",
  "checkin.gdpr-text2-offgrid": " of Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " and accept the ",

  "checkin.gdpr-button": "Privacy Policy",
  "checkin.gdpr-button-1": "Hotel Regulations",
  "checkin.gdpr-button-1-simplex": "Hotel House Rules",
  "checkin.gdpr-button-1-hostz": "Hotel House Rules",
  "checkin.gdpr-button-1-hostz-swissstay": "House Rules",
  "checkin.gdpr-button-1-offgrid": "General Terms & Conditions",
  "checkin.gdpr-button-2": "General Resolution N° 3971 (AFIP)",

  "checkin.terms-and-conditions": "Terms and Conditions",
  "checkin.hotel-regulations": "Hotel Regulations",
 "checkin.dniBack.required": "ID Back is required",
 "checkin.selfie.required": "Selfie is required",
  "checkin.terms-and-conditions-button-detail": "of the stay at the Hotel",
  "checkin.the_myde_selfie_message": "Please upload a <b>selfie of yourself holding your ID</b> (passport, ID card, or driver’s license). This helps us keep your stay safe and smooth.",
  "checkin.the_myde_selfie_message_title": "Important!",
  "checkin.signature": "Signature",
  "checkin.please-sign-here": "Please tap here to sign",
  "checkin.please-sign-below": "Please sign below",
  "checkin.confirm": "Confirm",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "I would like to receive hotel news and offers by email",
  "checkin.child": "Child",
  "checkin.child-s": "Child(s)",
  "checkin.children": "Children",
  "checkin.no-children": "No Children",
  "checkin.babies": "Babies",
  "checkin.years": "years",
  "checkin.no.name.yet": "Name not provided yet.",

  "checkin.dniFront.required": "ID Front is required",
  "checkin.selfie.required": "Selfie is required",
  "checkin.dniBack.required": "ID Back is required",

  "checkin.please-complete-your-checkin-title": "Pending Check-in",
  "checkin.please-complete-your-checkin-text": "Please complete your check-in by clicking here.",
  "general.notifications": "Notifications",
  "general.notifications_description": "Your personal settings on this app to customize your experience.",

  "cups.title": "Add-ons",
  "cups.remove_button": "Remove",
  "cups.add_button": "Add",
  "cups.subject_to_availability": "Subject to availability",
  "cups.subject_to_availability_text": "This item is subject to availability. During this process, no charges will be incurred, and upon selection, a hotel representative will contact you to provide further details about it.",
  "cups.preferedList_text": "Based on your interests we have these experiences for you",
  "cups.otherList_text": "Perhaps these these experiences might also interest you",
  "cups.tags.best-selling": "Best Seller",
  "cups.tags.most-popular": "Most Popular",
  "cups.tags.best-price": "Best Price",
  "cups.priceIsPerNight": "per night",
  "cups.confirm": "Confirm this purchase?",
  "cups.booked": "Booked",
  "cups.spots": "spots",

  "date.january": "January",
  "date.february": "February",
  "date.march": "March",
  "date.april": "April",
  "date.may": "May",
  "date.june": "June",
  "date.july": "July",
  "date.august": "August",
  "date.september": "September",
  "date.october": "October",
  "date.november": "November",
  "date.december": "Dicember",


  "maps.how_to_reach_us": "How to reach us?",
  "maps.get_directions": "Get directions",

  "room-categories.air-conditioning": "Air conditioning",
  "room-categories.complimentary-dressing": "Complimentary dressing",
  "room-categories.work-area": "Work area",
  "room-categories.private-balcony": "Private balcony",
  "room-categories.cable": "Cable",
  "room-categories.safe-box": "Safe box",
  "room-categories.sommier-beds": "Sommier beds",
  "room-categories.room": "Room",
  "room-categories.hydromassage": "Hydromassage",
  "room-categories.coffee-machine": "Coffee machine",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Hairdryer",
  "room-categories.selection-of-pillows": "Selection of pillows",
  "room-categories.ironing-service": "Ironing service",
  "room-categories.smart-tv": "Smart TV",
  "room-categories.king-size-bed": "King size bed",
  "room-categories.phone": "Phone",
  "room-categories.tv-lcd": "TV LCD",
  "room-categories.satellite-tv": "Satellite TV",
  "room-categories.street-view": "Street view",
  "room-categories.garden-view": "Garden view",
  "room-categories.sea-view": "Sea view",
  "room-categories.wifi": "Wifi",
  "room-categories.ketle": "Electric kettle",
  "room-categories.fridge": "Fridge",
  "room-categories.dishwasher": "Dishwasher",
  "room-categories.oven": "Oven",
  "room-categories.freezer": "Freezer",
  "room-categories.water-heater": "Water heater",
  "room-categories.plates-glasses": "Plates and glasses",
  "room-categories.cutlery-dishes": "Cutlery and dishes",
  "room-categories.microwave": "Microwave",
  "room-categories.kettle": "Electric kettle",
  "room-categories.nespresso-machine": "Nespresso machine",

  "room-categories.toilette-with-shower-box": "Reception toilette with shower box",
  "room-categories.sofa-bed": "Sofa bed",
  "room-categories.partial-sea-view": "Partial sea view",
  "room-categories.welcome-amenities": "Welcome amenities",
  "room-categories.shower": "Shower",
  "room-categories.bathtub": "Bathtub",
  "room-categories.double-sink": "Double sink",
  "room-categories.connected-rooms": "Connected rooms",
  "room-categories.king-or-twin-beds": "King bed or twin beds",
  "room-categories.los-troncos-view": "Los Troncos neighborhood view",
  "room-categories.daily-courtesy-water": "Daily courtesy water",
  "room-categories.daily-courtesy-capsule-dilmah": "Daily courtesy Dilmah capsule or infusion",
  "room-categories.stay-courtesy-capsule-dilmah": "Stay courtesy Dilmah capsule or infusion",

  "meeting_rooms.dvd-player": "DVD player",
  "meeting_rooms.high-speed-wi-fi": "High Speed WIFI",
  "meeting_rooms.independent-access": "Independent access",
  "meeting_rooms.lunch-service": "Lunch service",
  "meeting_rooms.meeting-room": "Meeting Room",
  "meeting_rooms.megaphone": "Megaphone",
  "meeting_rooms.microphone": "Microphone",
  "meeting_rooms.smart-tv": "Smart TV",
  "meeting_rooms.video-projection": "Video projection",
  "meeting_rooms.capacity": "Capacity:",
  "meeting_rooms.people": "people.",
  "welcome.title": "Welcome to our Hotel!",
  "welcome.subtitle": "We wish you a pleasant stay!",
  "welcome.text":
    "<b>My name is ViCo and I will be your virtual concierge!</b> I am available 24 hours a day and you can ask me anything! To do this, enter in the 'Request' section from where you can order room service, housekeeping, room supplies, etc",
  "welcome.text-costa-galana":
    "<b>With our Mobile Concierge service</b>, ou can receive personalized attention 24 hours a day to meet your preferences, requests, and recommendations... <br /><br />From the comfort of your device, you can request housekeeping, room service, restaurant, and spa reservations, among other things. <br /><br />Click on 'Start' and enter the Request section.<br /><br />If you wish, you can call extension 99 from your room.",
  "welcome.text-belair": "<b>Welcome to Grand Brizo Bel Air!</b><br /><br />We’re available 24/7 through this communication channel to assist you with anything you may need during your stay.<br /><br />In the <b>“Request”</b> section, you’ll find options to order room service, book hotel amenities, request housekeeping, and explore many other services designed for your comfort.",
  "welcome.text-hostz-becozy": "Welcome to our Becozy Basel, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-san-carlo": "Welcome to our Hotel San Carlo in Lugano, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-blacksummit": "Welcome to Black Summit Resort in Laax! In this portal, you will find everything you need to make the most of your stay.<br><br>Through this portal, you can elevate your experience with our available services, explore our property, discover things to do in the area, and much more.",
  "welcome.text-hostz-betahouse": "Welcome! You are now checked in.",
  "welcome.text-hostz-themyde": "<br/><br/><b>Welcome! You are now checked-in! </b>Find all your access details in the Access information section on your Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>Welcome! You are now checked-in! </b>Find all your access details in the Access information section on your Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Welcome! You are now checked in. You can now find all your access instructions in the Access Information section of your dashboard.",
  "welcome.text-hostz-steiners": "Welcome! You are now checked in. You can now find all your access instructions in the Access Information section of your dashboard.",

  "welcome.subtitle-offgrid": "Welcome to your Cabin Guide :)",
  "welcome.text-offgrid": "Here you'll find everything you need for your stay – from your <b>online check-in</b> and <b>arrival info</b> to helpful tips for your time in the cabin.<br><br>If you have any questions, feel free to reach out anytime – we're happy to help!<br>For urgent matters, just send us a message on <b>WhatsApp at +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉 <b>For easy access</b>, you can save the Cabin Guide to your home screen. Just tap <b>\"accept\"</b> and drag the icon to where you want it. It doesn’t take up any space and you can remove it anytime after your stay.<br><br><b>Have a wonderful stay!</b> 🌿",
  "welcome.footer-belair": "For easier access, we recommend adding a shortcut to this page on your phone’s home screen. It won’t take up space and can be easily removed once your stay ends.<br /><br />We’re here to ensure you have a pleasant and comfortable stay.<br /><br /><b>The Grand Brizo Bel Air Team</b>",
  "welcome.room-offgrid": "Cabin",
  "welcome.text-simplex": "Welcome! You are now checked in. You can now find all your access instructions in the Access Information section of your dashboard.",

  "welcome.footer-hostz": "For easy access, we recommend enabling notifications and creating a shortcut on your home screen. This will help you stay updated with important information regarding your stay and allow you to easily make requests to make your stay even more comfortable.",
  "welcome.footer-hostz-betahouse": "You can now find all your access instructions in the Access Information section of your dashboard.",

  "welcome.room": "Your room number is:",
  "welcome.room_bs": "Your apartment is:",
  "welcome.footer":
    "For easy access please allow me to create a shortcut in your home screen. You just need to click on accept and drag it where you want to put it. It does not take up space and you can remove it as soon as you leave the hotel.<br /><br /><b>It will be a pleasure to assist you!</b>",
  "welcome.start": "Start",
  "services.type.general": "Inquiries",
  "services.type.room_service": "Room Service",
  "services.type.pool_service": "Pool Service",
  "services.type.room_supplies": "Room Supplies",
  "services.type.laundry": "Laundry",
  "services.type.porter": "Porter",
  "services.type.tray_collection": "Tray Collection",
  "services.type.pressing": "Pressing",
  "services.type.housekeeping": "Housekeeping",
  "services.type.wakeup_call": "Wakeup Call",
  "services.type.car_valet": "Valet Parking",
  "services.type.concierge": "Concierge",
  "services.type.lost_objects": "Lost Objects",
  "services.type.breakage_report": "Breakage Report",
  "services.type.services_booking": "Services Booking",
  "services.type.review_tracking": "Resolution Ticket for Your Feedback",
  "services.type.up_selling": "Add-Ons",
  "services.type.items_sales": "Products",
  "services.housekeeping.do-not-clean-today": "Don't Clean my room Today",
  "services.housekeeping.horary":
    "Remember that the schedule to request room cleaning is from 10 a.m. to 3 p.m. Otherwise your room will not be cleaned.",
  "services.housekeeping.horary-costa-galana":
    "Remember that the schedule to request room cleaning is from 7 a.m. to 5 p.m.",
  "services.housekeeping.do-not-change-towels": "Don't change towels today",
  "services.housekeeping.button-title": "Send request",
  "services.donotdisturb.button-title-activate":
    "Turn ON <b>DO NOT DISTURB</b> Mode",
  "services.donotdisturb.button-title-disable":
    "Turn OFF <b>DO NOT DISTURB</b> Mode",
  "services.donotdisturb.extra-info":
    'As long as the <b>"DO NOT DISTURB"</b> mode is active, it will not be possible to clean up or respond to your requests.',
  "services.do-not-change-towels": "Do Not Change Towels",
  "services.sent-text":
    "<b>Request Sent!</b> As soon as it is processed you will be notified, you can also track it from the <b>Dashboard</b> screen. ",
  "services.go-to-requests": "Go to Dashboard",
  "services.go-to-home": "Go to Home",
  "services.status.pending": "Pending",
  "services.status.observed": "Review",
  "services.status.in_progress": "In Progress",
  "services.status.in_transit": "On the way",
  "services.status.accepted": "Accepted",
  "services.status.done": "Delivered",
  "services.status.canceled": "Canceled",
  "services.status.reviewed": "Reviewed",
  "services.status.on_hold": "Pending",
  "services.status.seated": "Fulfilled",
  "services.status.confirmed": "Confirmed",
  "services.active-request": "{0} active request!",
  "services.active-requests": "{0} active requests!",
  "select...": "Select...",
  "services.confirm-request": "Is your order complete?",
  "services.type.gift_store": "Gift Store",
  "smartlocks.swipe-to-open": "SWIPE TO OPEN",
  "smartlocks.pin-code-arosa-explanation": "After entering the PIN CODE, you must press the # or ↵ (enter) buttons to confirm.",
  "status.messages": "New messages!",
  "status.no_messages": "We have not yet responded to your inquiry about this matter. We will get back to you shortly.",
  "status.more": "More about your stay",
  "status.faqs": "Frequently Asked Questions",
  "status.faqs_description": "All the information in one place",
  "status.contact": "Contact us",
  "status.contact_whatsapp": "Whatsapp us",
  "status.contact_description": "We are here to help!",
  "status.settings.btnDescription_facilities_arosa":"Great offers from our partners",
  "status.checkin_alert": "Updates on your Check-In",
  "status.checkin_alert_offgrid": "News about your Check-in",
  "status.checkin_edit": "Update check in information",
  "status.checkout_description": "Register your checkout",
  "status.checkin.chat": "Checkin Messages",
  "status.stay.info": "Stay Info",
  "status.stay_description": "Information about your stay",
  "status.checkin.chat-desc": "Messages during your check-in process",
  "status.settings": "Notifications",
  "status.settings_description": "Manage your settings",
  "status.wifi": "WiFi",
  "status.wifi_description": "WiFi access",
  "status.wifi_name": "Network name",
  "status.wifi_password": "Password",
  "status.wifi_no_password": "No password required",
  "status.garbage": "Garbage Disposal Instructions",
  "status.parking_info": "Parking Instructions",
  "status.extra-bed": "Extra bed instructions",
  "status.extra-bed_description": "Watch how to set up your extra bed.",
  "status.garbage_description": "All you need to know",
  "status.parking_info_description": "All you need to know",
  "status.access_code": "Access codes",
  "status.room_access_code": "Room Access Codes",
  "status.room_keys": "Room keys",
  "status.room_keys_description": "Collect them at the keyboxes in the lobby",
  "status.room_keys_description_becozy": "Collect them in the keybox on your room's door",
  "status.room_keycard": "Room key card",
  "status.room_keycard_description": "Just collect them at reception",
  "status.apartment_keys": "Apartment keys",
  "status.apartment_keys_description": "Just collect your keys from the keybox at the main entrance",
  "status.access_code_one": "Access code",
  "status.access_code.pin_code": "PIN code",
  "status.access_code_hostz": "Apartment Access codes",
  "status.access_information": "Access Information",
  "status.apartment_access": "Apartment Access  ",
  "status.access_information_extramsg_steiners": "Reception is open every day between {0} and {1} and it is located after the main entrance door, on the left",
  "status.access_information_description": "All you need to access the property",
  "status.access_code_description": "Access Information",
  "status.access_code.main_entrance": "Entrance door",
  "status.access_code.main_door": "Main entrance access code",
  "status.access_code.room_door": "Room lockbox code",
  "status.access_code.ladder": "Staircase code",

  "status.access_information.access_to_room_themyde": "Access to your Apartment",
  "status.access_code.ladder_themyde": "Main entrance door / Staircase code",

  "status.access_code.hostz-becozy": "At the main entrance of the hotel, you will find a keypad on the left-hand side. Enter the access code for the hotel to gain entry.<br><br>Once inside, the key to your room will be in a lockbox directly attached to your room door.To open the lockbox, enter the code and pull the small lever on the left to open the box and collect your room key.",

  "status.access_information.access_to_hotel": "Access to the Hotel",
  "status.access_information.accesses_swissstay": "Access",
  "status.access_information.access_to_room": "Access to your Room",

  "status.access_code.main_entrance_themyde": "DOORS & ENTRYWAYS",
  "status.access_information.access_to_room_cover": "During your stay, you will find here the instructions to obtain the access keys",
  "status.access_information.access_to_room_cover_arosa": "Available at 4pm",
  "status.access_information.access_to_room_cover_sigma": "Available at 4pm",

  "status.access_information.access_to_room_description_cozy": "Get your key card from the green keyboxes in the lobby (Keynest)",
  "status.access_information.access_to_room_description_steiners": "Get your key card from the green keyboxes located on the 2nd floor.",
  "status.access_information.main_entrance_description_steiners": "The door is open during the day. <br>If it is closed, please use the code here under to open the KEYBOX N.1 and use the digital card inside to open the main door.",

  "status.access_instructions": "Access Instructions",
  "status.access_instructions_description": "Your access procedure",
  "status.access_code.key_collection_code": "Key Collection Code",
  "status.access_code.key_dropoff_code": "Key Drop off Code",
  "status.access_code.key_dropoff": "Key Drop off",
  "status.access_code.key_dropoff_instructions": "Drop the key in the black box next to the green box where you picked up your keys",
  "status.access_code.key_card_collection_code": "Key card collection code",
  "status.access_code.key_card_dropoff_code": "Key card drop off code",

  "status.access_information.before_checkin": "Access details will be available on the check-in day.",
  "status.access_information.before_checkin_with_hours": "The code of the hotel's main entrance will be visible from {0} on check in day. Your room's details (number and keybox code) will be visible from {1} on check in day.",
  "status.access_information.before_checkin_with_hours_themyde": "You will be able to see your access information at {0} (check-in time)",
  "status.access_information.before_checkin_with_hours_cozy": "Access information will be visible on the check in day at {0}, only if the check-in form has been completed and the payment has been settled (included the security deposit of {1})",
  "status.access_information.before_checkin_with_hours_steiners": "Access information will be visible on the check in day at {0}, only if the check-in form has been completed. If you just paid for the reservation and check-in time has already passed, please allow 3-5 minutes for the transaction to be processed, and once approved, the information will be visible.",
  "status.access_information.before_checkin_with_hours_no_sd": "Access information will be visible on the check in day at {0}, only if the check-in form has been completed and the payment has been settled.",
  "status.access_information.before_checkin_main": "You are more than welcome to enter the hotel and enjoy its facilities starting from {0} in the morning. You can also drop your luggage in the storage while you wait for your room to be ready at check-in time at {1}. You room's details will be shared at {1}.",
  "status.access_information.before_checkin_room": "The code of the hotel's main entrance will be visible from {0} on check in day. Your room's details (number and keybox code) will be visible from {1} on check in day.",
  "status.access_information.after_checkin": "Your stay has ended, and your access details are no longer available. Thank you for visiting our hotel — we hope to welcome you again soon!",
  "status.access_information.main_entrance": "Main entrance",
  "status.access_information.main_entrance_code": "Main entrance code",
  "status.access_information.main_entrance_code_sigma": "Main & Back entrance code",
  "status.access_information.main_entrance_code_swissstay": "Main access",
  "status.access_information.main_entrance_code_and_skiroom_code": "Main entrance code & Skiroom code",
  "status.access_information.room_keybox_code": "Room keybox code (located next to your room's door)",
  "status.access_information.room_keybox_code_arosa": "Room keybox code (the keybox is located ON YOUR ROOM DOOR)",
  "status.access_information.please_use_main_key": "Please use MAIN KEY",
  "status.access_information.link_modal_video": "Watch this short video to see how check-in works",
  "status.access_information.link_modal_video_themyde": "Watch this short video to see how check-in works",
  "status.access_information.title_modal_video": 'How to use',
  "status.access_information.room_lock_box_code": "Lockbox code",
  "status.access_information.room_lock_box_location": "Lockbox location",

  "status.location": "Location",
  "status.location_description": "Get directions to the property.",
  "status.location_description_swissstay": "Get direction to the apartment.",
  "status.parking": "Parking",
  "status.parking_description": "Access & Rules",

  "bookable.limit": "Book before",

  "account.add-device": "Add Device",
  "account.stay": "Stay",
  "account.room": "Room",
  "account.more-info": "More Info",
  "account.guest": "Guest",
  "account.charges": "Charges",
  "account.payments": "Payments",
  "account.accommodation": "Accommodation",
  "account.accommodation_description": "Night of accommodation",
  "account.citytax": "City Tax",
  "account.foodandbeverages": "Food & Beverages",
  "account.foodandbeverages_description":
    "Consumption of bar, restaurant, etc.",
  "account.other": "Other Charges",
  "account.other_description": "Other costs of the stay",
  "account.download": "Download",
  "account.invoices": "Invoices",
  "account.balance": "Balance",
  "account.chat": "If you have any questions about the invoice, feel free to contact us.",

  "review.rate": "Rate:",
  "review.rate_us": "Rate Us!",
  "review.thanks": "Thank you for rating us!",
  "review.extra_rate": "Aditional Feedback",
  "review.extra_rate_text": "These ratings help us improve our service",
  "review.sending_response": "Sending response…",
  "review.rate-placeholder": "Please leave your feedback here...",
  "review.already-rated": "Thank you for rating us, your feedback is very valuable.",
  "review.already-rated-button": "I would like to change my rate.",
  "review.average": "Average",
  "review.general": "General",
  "review.contact": "Kindly share your contact details so we can follow up on your review.",
  "review.flow_ok": "OK",
  "review.flow_submit": "Submit",
  "review.flow_required_hint": "Please answer this question to continue.",
  "review.rating_scale_hint": "1 star is very poor, 5 is excellent",
  "review.validation_name_min": "Name must be at least 3 characters long.",
  "review.validation_email": "Please enter a valid email address.",
  "review.validation_phone": "Phone number must be at least 6 digits long.",
  "review.screen_title": "Review",
  "review.flow_type_rating": "Rating",
  "review.flow_type_single_choice": "Single choice",
  "review.flow_type_opinion_scale": "Opinion scale",
  "review.flow_type_ranking": "Ranking",
  "review.flow_type_landing": "Landing",

  "request.detail-title": "Request Detail",
  "request.delivery-point": "Delivery Point",
  "request.your-request": "Your Request",
  "request.customize_next": "Customize it on the next screen",
  "request.continue_customize": "Continue & Customize",
  "request.products_not_available": "Products not available at this time",
  "request.product_not_available": "Product not available at this time",
  "request.available-time": "Product available at the following times",
  "request.item-out-of-hours": "Product not available at this time",
  "request.available-time-from-to": "{0} to {1}hs",
  "request.product": "Product",
  "request.products": "Products",
  "request.creating-order": "Creating order",
  "request.creating-order-title": "We are creating your order",
  "request.creating-order-description": "We are sending your order to the hotel. This takes only a few seconds.",
  "request.order-created": "Order created",
  "request.order-created-title": "Order created successfully",
  "request.order-created-description": "Your order has been registered. In a moment we will take you to the detail so you can track it.",
  "request.redirecting-to-order": "Redirecting to the detail in",
  "request.view-order-now": "View order now",
  "request.status-pending": "Pending",
  "request.confirm-cancel":
    "This will cancel your request. Do you want to proceed?",
  "request.only-one-for-type":
    "You can only have one open request of this type!",
  "request.lost_objects.observation":
    "Describe here the objects you have lost in detail and when and where you might have lost them",
  "request.generic.observation": "If you wish, leave a comment here.",
  "request.general.observation": "Please, tell us how we can help you today!",
  "request.car_valet.observation": "Let us know how we can assist you with your vehicle...",
  "request.tray_collection.observation": "Any special instructions for your collection?",
  "request.breakage_report.observation": "Please let us know what is broken/missfunctioning",
  "request.housekeeping.observation": "Please let us know if you have any especial requirements here",
  "services.type.beach_service": "Beach service",
  "service.type.request": "Request",

  "request.option": "Option",
  "request.observations": "Comments",
  "request.observations-placeholder": "Please write down your observations; we will strive to follow them to the letter.",
  "request.create.comment": "Leave a comment on your request",
  "request.reserved-days": "Reserved Days",
  "public.personal-information": "Personal information",
  "public.input.number": "Number",




  "notifications.enable": "Enable Notifications",
  "notifications.not_now": "Not Now",
  "notifications.accept":
    "<b>Important:</b> Please enable notifications so you can receive real-time status updates on your requests!",
  "notifications.accepted":
    '<b class="text-success">Notifications Enabled!</b> You will receive real-time updates on your check-in process and requests during your stay!',
  "notifications.blocked":
    '<b class="text-danger">Notifications Blocked!</b> Please allow notifications so we can send you important status updates on your requests! Click the lock icon in the address bar of your browser. Click to toggle the Notifications switch on. Thanks!',
  "notifications.confirm-continue":
    "<b>Are you sure you want to continue?</b> Notifications will improve your overall experience during your stay with us!",
  "notifications.empty-title": "You have no notifications yet!",
  "notifications.empty-text": "When you get one it will show up here.",
  "notificacions.title": "Notificacions",
  "notifications.link.make-the-review": "Make Review",

  "stay.add-device-use-qr":
    "Use the QR from another device to add it to the stay.",

  "yup.required": "Field is mandatory",
  "yup.only-letters": "Only letters are allowed",
  "yup.only-numbers": "Only numbers are allowed",
  "yup.only-numbers-and-letters": "Only numbers and letters",
  "yup.minimal-6-digits": "It must contain at least 6 digits",
  "yup.minimal-7-digits": "It must contain at least 7 digits",
  "yup.minimal-2-letters": "It must contain at least 2 letters",
  "yup.maximal-50-letters": "It must contain no more than 50 letters",
  "yup.maximal-12-digits": "It must contain no more than 12 digits",
  "yup.maximal-25-digits": "It must contain no more than 25 digits",
  "yup.wrong-date": "Wrong Date",
  "yup.please-review": "Please, review this value",
  "yup.email-invalid-format": "Incorrect email format",

  "toast.do-not-disturb-mode-active-title": '"Do not disturb" mode active',
  "toast.do-not-disturb-mode-active-text":
    "In order to make new requests you first need turn do not disturb mode off.",
  "toast.do-not-disturb-mode-active-link": "Turn off",

  "payments.summary-of-charges": "Summary of Charges",
  "payments.guarantee-deposit-paid": "Your reservation already has an active security deposit.",
  "payments.balance-paid": "Your reservation has no outstanding balance.",
  "payments.total-to-pay": "Total to pay",
  "payments.pay": "Go to pay",
  "payments.retry-pay": "Retry payment",
  "payments.items-pay-with-deposit": "The charges to be paid are listed below:",
  "payments.guarantee-deposit": "Security Deposit",
  "payments.guarantee-deposit-desc": "This amount will be placed on hold but will not be charged to your credit card.",
  "payments.select-items-pay": "Select the items you wish to pay",
  "payments.payment-ok": "Your payment was made successfully",
  "payments.payment-error": "An error occurred while trying to make the payment",
  "payments.payment-not-authorised": "Payment not authorised",
  "payments.pending-confirmation": "We are confirming your payment with the bank. Please do not close this screen.",
  "payments.pending-timeout": "Payment confirmation is taking longer than usual. Please try again or contact reception.",
  "payments.payment-unavailable-continue": "Payment is not available at the moment, you can continue with web check-in and pay later.",
  "payments.loading-component": "Loading payment component...",
  "payments.later": "I will pay later",
  "payments.confirm-pay-later": "You will confirm the order and pay later. Use the Buy button below.",
  "payments.back-to-pay-later": "choose to pay later",
  "payments.later-sancarlo": "Pay in cash at the reception. Please note that our reception is open from 9:00 AM to 6:00 PM. If you are arriving after 6:00 PM, this option will not be available to you.",
  "payments.msg_guarantee": "At Black Summit Laax, we require a security deposit to ensure a safe and enjoyable stay for all our guests. This deposit acts as a precautionary measure to cover any potential damages to the property, furniture, or amenities, as well as incidental charges such as additional cleaning or late check-outs. The deposit will be released 7 days after check-out, once the property has been inspected and no issues are found. The refund will be processed to your original payment method.",
  "payments.msg_guarantee_72hs": "Please be reminded that a deposit of {0} CHF must be collected as a mandatory measure 72 hours prior to your arrival. You will receive an email notification as a reminder.",
  "payments.older": "Previous payment",

  "facilities.Carta_Belleza": "Beauty Menu",
  "spa.Carta_Tratamientos": "Massage Menu",
  "facilities.Carta_SPA": "Menu",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Book a room",
  "home.book-an-apartment": "Book an apartment",

  "door.main": "Main",
  "door.back": "Back",
  "room.address": "Address",
  "room.number": "Room number",
  "room.floor": "Room floor",
  "apartment.address": "Apartment address",
  "apartment.number": "Apartment",
  "apartment.floor": "Apartment floor",

  "public.bookable.init": "Please select the number of people and the date you want to check availability",
  "public.bookable.sent-text": "<b>Request Sent!</b> <br/>You will be notified once your booking has been processed.",
  "public.bookable.fill-data": "Please fill in the following information to complete your reservation for the day:",
  "public.edit-hour": "Edit time",
  "public.input.name-and-surname": "Name and Surname",
  "public.input.phone": "Phone",
  "public.input.email": "Email",
  "public.input.observations": "Observations",
  "public.bookable.gala-experience": "Have you attended a Hotel Gala before?",
  "public.bookable.gala-experience.required": "Please select an option",
  "public.bookable.list-empty": "No services available for booking.",
  "public.dashboard.home": "Home",
  "public.dashboard.services": "Services",
  "public.dashboard.my-profile": "My profile",
  "public.reservation.status.accepted": "Request accepted",
  "public.reservation.status.canceled": "Canceled",
  "public.reservation.status.pending": "Requires confirmation",
  "public.reservation.status.confirmed": "Confirmed",
  "public.request.confirmed": "Request confirmed at",
  "public.request.status.canceled-msg": "The request has been canceled.",
  "complete-to-web-checkin": "Web Check-In",

  "services.make-your-reservation": "Make your reservation",  
  "services.make-your-reservation-button": "Reserve our services",

  "public.reservation.not-found": "Reservation details not found",
  "public.reservation.welcome": "Hi {0}, here are your reservation details:",
  "public.reservation.date-and-hour": "Date and time",
  "public.reservation.people": "People",
  "public.reservation.adults": "Adults",
  "public.reservation.adult": "Adult",
  "public.reservation.children": "Children",
  "public.reservation.child": "Child",
  "public.reservation.state": "Status",
  "public.request.cancel-assistance": "Cancel assistance",
  "public.request.cancel-request": "Cancel",
  "public.reservation.status.remember-status": "Accepted",
  "public.dashboard.logout": "Logout",
  "public.dashboard.welcome": "Welcome, {0}!",
  "public.dashboard.no-reservations": "You don't have any active reservations",
  "public.reservation.observations": "Observations",
  "public.reservation.view-reservations": "View all my reservations",
  "public.reservation.confirm": "Confirm",
  "public.reservation.confirm_msg": "You can confirm your reservation up to 72 hours before the start time.",
  "public.reservation.status.validating": "Processing request",
  "public.request.status.validating-msg": "Your request is being processed, we will notify you when it is ready.",
  "public.reservation.confirmated-at": "Reservation confirmed on",
  "public.request.forbidden.title": "This request cannot be displayed",
  "public.request.forbidden.description": "This request does not correspond to the current user {0}. If you want to continue this action, your current session will be closed and you will be redirected to the new one.",
  "public.request.forbidden.button": "Go to dashboard",
  "public.reservation.status.accepted": "Accepted",
  "public.reservation.status.confirmed": "Confirmed",
  "public.dashboard.requests": "Requests",
  "public.dashboard.not-found": "User profile not found",
  "public.dashboard.my-data": "My information",
  "public.dashboard.name": "Full name",
  "public.dashboard.email": "Email",
  "public.dashboard.phone": "Phone",
  "public.dashboard.my-reservations": "My reservations",
  "public.dashboard.my-requests": "My requests",
  "public.request.not-found": "Request details not found",
  "public.request.welcome": "Hi {0}, here are your request details:",
  "public.request.date-and-hour": "Date and time",
  "public.request.people": "People",
  "public.request.passengers": "Passengers",
  "public.request.title": "Request details",
  "public.request.state": "Status",
  "public.request.observations": "Observations",
  "public.request.additional-observations": "Additional observations",
  "public.request.view-requests": "View all my requests",
  "public.request.confirm-assistance": "Confirm assistance",
  "public.dashboard.go-to-my-reservations": "Go to my reservations",
  "public.request.payment-status.pay-again": "Retry payment",
  "public.request.payment-status.not-captured": "Payment could not be captured. Please try again to finalize your request.",
  "public.dashboard.cgbeach.public_cart": "Place Order",
  "menu.all": "All",
  "menu.search": "Search in the menu...",
  "menu.search_room_service": "Search product...",
  "menu.search_restaurant": "Search in Restaurant...",
  "menu.category": "Category {0}",
  "menu.vegetarian": "Vegetarian",
  "menu.gluten_free": "Gluten Free",
  "menu.items_not_found": "No items configured for this service. Please consult the administrator.",
  "menu.fail_laod_items": "Error loading service items. Please try again later.",
  "menu.price_without_taxes": "Price without national taxes:",

  "no-hours.disabled.day": "This service will not be available today.",
  "no-hours.disabled.general": "Out of hours",
  "no-hours.disabled.slot": "This service is not available at the moment. Please try again later.",
  "general.select-days": "Select days",
  "general.select-day": "Select day",
  "general.selected-days": "Selected days",
  "general.selected-day": "Selected day",
  "general.day": "day",
  "general.invalid-dates": "Rates are not available for periods longer than {0} days.",
  "general.no-rates-available-for-selected-dates": "No rates available for the selected dates.",
  "general.must-select-passengers": "Select quantity and passengers in at least one passenger category.",
  "public.input.location": "Location",
  "public.input.location.arena": "Arena umbrella",
  "public.input.location.piscina": "Pool umbrella",
  "public.input.location.carpa": "Tent",
  "public.input.tent": "Tent number",
  "general.processing-request": "Processing request...",
  "upselling.no-availability": "This option is currently not available for your stay.",
  "general.payment-method": "Payment method",
  "general.select-passengers": "Select passengers",
  "general.select-passenger": "Select passenger",

  "days.sunday": "Sunday",
  "days.monday": "Monday",
  "days.tuesday": "Tuesday",
  "days.wednesday": "Wednesday",
  "days.thursday": "Thursday",
  "days.friday": "Friday",
  "days.saturday": "Saturday",

  "public_cart.hours-label": "Opening hours",
  "public_cart.no-available-hours": "No available hours",
  "CHECKINS_FOUND_NONE_VALID": "This reservation is not yet available for check-in. Please try again on your arrival date",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "There was a problem finding the reservation by room. Please try using the reservation code",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "We couldn't find the reservation",
  "kiosk.welcome.subtitle": "Check-in completed successfully",
  "kiosk.back": "Back",
  "kiosk.room": "Room",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Scan to access your guest services",
  "kiosk.scan_qr": "Scan to access your guest services",
  "kiosk.generating_qr": "Generating QR...",
  "kiosk.redirect_warning": "Redirecting you in {seconds} seconds...",
  "kiosk.go_to_identify": "Finish",
  "kiosk.logout.title": "Logout from Kiosk",
  "kiosk.login.title": "Enter your PIN",
  "kiosk.login.description": "Please enter the access code to continue",
  "kiosk.login.button_access": "Access",
  "kiosk.login.button_loading": "Loading...",
  "kiosk.login.error_empty": "Please enter the PIN",
  "kiosk.login.error_invalid": "Invalid PIN. Try again.",
  "kiosk.login.error_process": "Error processing login. Try again.",
  "kiosk.login.copyright": "© {year} {hotel}. All rights reserved.",
  "kiosk.login.pin": "Enter PIN",
  "kiosk.logout.confirm": "Enter your PIN to logout from Kiosk",
  "kiosk.receiving-info": "Receiving information...",
  "kiosk.inactivity-warning-title": "Are you still there?",
  "kiosk.inactivity-warning-message": "You have been inactive. If you don't respond in the next few seconds, your session will end automatically.",
  "kiosk.inactivity-countdown": "Session will close in",
  "kiosk.inactivity-stay": "Yes, continue",
  "kiosk.inactivity-logout": "No, logout"
};
